
import React from 'react';

export const CalendarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    calendar_month
  </span>
);